import { module } from 'modujs';
import { html } from '../utils/environment';
import { GtagHandler } from '../app'

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'escape'
        }
    }

    init() {
        this.urls = [
            'https://erableduquebec.ca/recettes/gratin-de-navets-et-de-pommes-a-lerable/',
            'https://www.ricardocuisine.com/recettes/5864-crepes-fines-a-dejeuner',
            'https://www.ikea.com/ca/en/cat/shelf-units-11465/',
            'http://meteomedia.ca'
        ];

        const random = Math.round(Math.random() * (this.urls.length - 1));

        this.el.href = this.urls[random];
    }

    escape() {
        GtagHandler.emit('escape')

        html.innerHTML = '';
        window.document.title = '';
    }
}
